import React from 'react';
import { ICard } from '../../../types/Card';
import { DH } from '../../../utils/DataHook';
import { CardViewCollapsed, CardViewExpanded } from './elements/CardView';

interface ICardsListMobileProps {
  isRemovingInProcess: boolean;
  cards: ICard[];
  showRemoveConfirmation: boolean;
  expandedCard: ICard | undefined;
  expandCard: (cardId: string) => void;
  collapseCard: () => void;
  rtl: boolean;
}

export const CardsListMobile: React.FC<ICardsListMobileProps> = (props) => {
  const { cards, expandCard, expandedCard, collapseCard, isRemovingInProcess, showRemoveConfirmation, rtl } = props;

  return (
    <div data-hook={DH.CardsListInnerWrapper.Mobile}>
      {expandedCard ? (
        <CardViewExpanded
          isRemovingInProcess={isRemovingInProcess}
          expandedCard={expandedCard}
          collapseCard={collapseCard}
          showRemoveConfirmation={showRemoveConfirmation}
          rtl={rtl}
        />
      ) : (
        <CardViewCollapsed expandCard={expandCard} cards={cards} rtl={rtl} />
      )}
    </div>
  );
};
